import React from 'react';
import { AuthProvider } from './src/context/AuthContext';

// custom typefaces & global styles
require("./src/normalize.css");
require("bootstrap/dist/css/bootstrap.min.css");
require("bootstrap/dist/js/bootstrap.min.js");
require("@popperjs/core/dist/umd/popper.min.js");
require("@fontsource-variable/montserrat");
require("./src/style.scss");
require("prismjs/themes/prism-tomorrow.css");

export const wrapRootElement = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>;
};
